import { Link } from 'react-router-dom';
import type { Me } from '../api/types';
import { useAdminAuth } from '../auth';

/**
 * The rail down the left of every screen: the wordmark, the one nav item, and
 * who is signed in.
 *
 * One nav item, so it is always the current one. The restraint is the same rule
 * the rest of this surface follows — no chips, no status cards, no counts — and
 * the foot is the only place the operator's own identity is printed.
 */
export function NavRail({ me }: { me: Me | null }) {
  const { who, signOut } = useAdminAuth();

  return (
    <nav className="nav">
      <div className="wordmark">Arbiter</div>
      <ul>
        <li>
          {/* One nav item, so it is always the current one. A `Link` rather
              than an `<a href>` since the router arrived: from an org page the
              anchor was a full page load, which threw away the org list this
              app had just read. */}
          <Link to="/" className="active">
            Orgs
          </Link>
        </li>
      </ul>
      <div className="nav-foot">
        <div>Admin</div>
        <div className="who">{me?.user.name ?? me?.user.email ?? who}</div>

        {/* Auth0 mode only — dev auth has no session to end. */}
        {signOut ? (
          <button type="button" className="btn act tiny sign-out" onClick={signOut}>
            Sign out
          </button>
        ) : null}
      </div>
    </nav>
  );
}
